module.exports = __webpack_public_path__ + "img/interactive-fountain_2.c8b6bf25.jpg";